<template lang="pug">
  .child-wrap
    .child-content
      .prefix
        font-awesome-icon.status-icon(v-if="hasRoles" @click="toggleRoles()" :color="status" icon="industry")
        font-awesome-icon.status(v-if="subChild" :color="status" icon="circle")
      credential-link.record(:with-challenge="true" :data-test-id="subChild ? 'oor-credential' : 'le-credential'")
        p(:class="isRevoked ? 'revoked': 'isActive'")
          span.status {{childName}}
          font-awesome-icon.revokedIcon(v-if="isRevoked" color="#DC1A45" icon="circle")
          span.revokedDate(v-if="isRevoked") Revoked ({{revokedAt}})
        p.subinfo(:class="isRevoked ? 'revoked': ''") {{credentialSaid}}
    .sub-children(v-if="show && hasRoles")
      div.loading-wrap(v-if="loading")
        font-awesome-icon.loading(icon="spinner" spin)
      div(v-else)
        credential-details(
          v-for="(role, i) in roles",
          :key="i",
          :credential="role",
          :subChild="true"
          )
      show-more(v-if="showButton", @show-more="showMoreRoles", align="left")
</template>
<script>
import { mapActions, mapGetters, } from 'vuex'
import CredentialLink from './CredentialLink'
import CredentialStatus from './CredentialStatus'
import ShowMore from '@/components/record-details/ShowMore'

export default {
  name: 'CredentialDetails',
  components: {
    ShowMore,
    CredentialLink,
    CredentialStatus,
  },
  props: {
    credential: {
      type: Object,
      required: true,
    },
    subChild: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      roles: [],
      show: true,
      currentPage: 1,
      lastPage: 1,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('record', [ 'companyName', ]),

    showButton () {
      return this.currentPage < this.lastPage
    },
    childName () {
      return this.credential.attributes.personName
        ? `${this.credential.attributes.personName},  ${this.credential.attributes.personRole}`
        : this.companyName
    },
    credentialSaid () {
      return this.credential.attributes.said
    },
    hasRoles () {
      return this.credential.type === 'le-credentials' ? true : false
    },
    revokedAt () {
      return this.credential.attributes.revokedAt
    },
    isRevoked () {
      return this.credential.attributes.revokedAt !== null
    },
    status () {
      return this.isRevoked ? '#9ca3af' : ''
    },
  },
  mounted () {
    this.fetchInitialRoleCredentials()
  },
  methods: {
    toggleRoles () {
      this.show = !this.show
    },
    showMoreRoles () {
      this.currentPage++
      this.getRoleCredentials({
        page: this.currentPage,
        credentialSaid: this.credentialSaid,
      }).then(({ data, meta, }) => {
        this.lastPage = meta.page.lastPage
        this.roles = [ ...this.roles, ...data, ]
      })

    },

    fetchInitialRoleCredentials () {
      this.loading = true
      if (this.hasRoles) {
        this.getRoleCredentials({
          page: 1,
          credentialSaid: this.credentialSaid,
        }).then(({ data, meta, }) => {
          this.roles = data
          this.lastPage = meta.page.lastPage
          this.loading = false
        })
      }
    },
    ...mapActions('credential', [ 'getRoleCredentials', ]),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"
  .child-wrap
    display flex
    flex-direction column

    .status
      font-size 14px

    .status-icon
      cursor pointer

    .subinfo
      font-family 'Lucida Console', monospace
      color #4b5563
      font-size 70%
      font-style italic

    .isActive
      color #003336
      font-weight 600

    .revoked
      color #6b7280

    .revokedIcon
      font-size 11px
      margin-left 8px

    .revokedDate
      font-size 0.75rem
      color #4b5563
      margin-left 5px
      font-weight 600

    inner
    .lapsed
      text-decoration: underline #CD5C5C
      text-underline-offset: 3px
      text-decoration-thickness: 2px

    .published
      text-decoration: underline #4682B4
      text-underline-offset: 3px
      text-decoration-thickness: 2px

    .record
      flex-grow 1

    .child-content
      display flex
      align-items center
      position relative
      margin-bottom 1rem


      .prefix
        font-size 120%
        color $default-color
        width 1.5rem

    .sub-children, .empty
      padding-left 1.5rem

      .align-start
        justify-content flex-start

      .loading-wrap
        display flex
        align-items center

        .loading
          font-size 1.2rem
          color $turquoise-color
    .empty
      font-size 95%
      color $default-color-middle
</style>



// WEBPACK FOOTER //
// src/components/record-details/credentials/CredentialDetails.vue